define('taoQtiItem/qtiItem/core/feedbacks/FeedbackBlock',['taoQtiItem/qtiItem/core/feedbacks/Feedback'], function(Feedback){
    var FeedbackBlock = Feedback.extend({});
    return FeedbackBlock;
});
